import React from 'react';
import classNames from 'classnames';

const BaseFilterTab = (props) => {
  const {
          valueKey,
          labelKey,
          action,
          active,
        } = props;

  const onclick = (event, valueKey) => {
    event.preventDefault();
    event.stopPropagation();

    action(valueKey);
  };

  return (
    <span
      className={classNames({ 'active': active === valueKey })}
      onClick={(event) => onclick(event, valueKey)}
    >
        {labelKey}
      </span>
  );
};

export default BaseFilterTab;